import { render, staticRenderFns } from "./addLabeltemplate.vue?vue&type=template&id=305b0c5b&scoped=true"
import script from "./addLabeltemplate.vue?vue&type=script&lang=js"
export * from "./addLabeltemplate.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "305b0c5b",
  null
  
)

export default component.exports